import { render, staticRenderFns } from "./sorting.vue?vue&type=template&id=63f75570&scoped=true"
import script from "./sorting.vue?vue&type=script&lang=js"
export * from "./sorting.vue?vue&type=script&lang=js"
import style0 from "./sorting.vue?vue&type=style&index=0&id=63f75570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f75570",
  null
  
)

export default component.exports